import React, { useEffect } from 'react';

import classes from './Timer.module.scss';
import { useTimer } from '../../../../../../shared/hooks/useTimer';

type TimerProps = {
  expirationEpoch: number;
  onTimeOver: () => void;
};

const Timer = ({ expirationEpoch, onTimeOver }: TimerProps) => {
  const { minutes, seconds, isTimeOver } = useTimer(expirationEpoch);

  useEffect(() => {
    if (isTimeOver) {
      onTimeOver();
    }
  }, [isTimeOver]);

  return (
    <div className={classes.container}>
      <div className={classes.timeContainer}>
        <p className={classes.time}>{minutes}</p>
        <p className={classes.description}>minutes</p>
      </div>
      <p className={classes.divider}>:</p>
      <div className={classes.timeContainer}>
        <p className={classes.time}>{seconds}</p>
        <p className={classes.description}>seconds</p>
      </div>
    </div>
  );
};

export { Timer };
